//
//
//
//
//
//

export default {
  name: 'product-card-info-item-software',
  props: {
    element: Object,
  },
  computed: {
    softwareRequired() {
      return _.get(this.element, 'mediaTypeDetails.softwareRequired', null);
    },
    softwareRequiredVersionName() {
      return _.get(this.softwareRequired, 'versionName') || '';
    },
  },
};
